export default __webpack_public_path__ + "static/media/slide.3c8db537.mp3";